import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

import CommonFiltersColumn1 from '../../../../Common/Filters/Column1';
import CommonFiltersColumn2 from '../../../../Common/Filters/Column2';
import CommonFiltersColumn3 from '../../../../Common/Filters/Column3';

import FilterCardSelectArray from '../../../../Common/FilterComponents/FilterCardSelectArray';
import FilterRegions from '../../../../StaticData/FilterRegions';

type Props = {
  record: any
};

const FiltersTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Grid columns={3}>
      <Grid.Column>
        <CommonFiltersColumn1 record={props.record} resource="campaign_rtbs" />
        <Form.Field>
          <FilterCardSelectArray title="Region" rootName="segment_attributes.filter_region_attributes" values={props.record.segment_attributes && props.record.segment_attributes.filter_region_attributes && props.record.segment_attributes.filter_region_attributes.values} choices={FilterRegions} /><br />
        </Form.Field>
      </Grid.Column>
      <Grid.Column>
        <CommonFiltersColumn2 record={props.record} resource="campaign_rtbs" />
      </Grid.Column>
      <Grid.Column>
        <CommonFiltersColumn3 record={props.record} resource="campaign_rtbs" />
      </Grid.Column>
    </Grid>
  </div>
);

export default FiltersTab;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Rtb/Partials/FiltersTab.tsx